export enum ReportDistribution {
  Day = 'day',
  Hour = 'hour',
  Month = 'month',
  Year = 'year',
  DayHours = 'day-hours',
}
